<template>
	<div class="home">
		<van-nav-bar
		  	title=""
			left-arrow
		  	@click-left="$router.back(-1)">
			<!-- <van-icon name="./static/img/ok.png" slot="right" @click="patchDish()" style="font-size: 24px;"/> -->
		</van-nav-bar>
		<div class="setting"><div>{{$t('NoData.buy')}}</div><div>{{$t('NoData.sale')}}</div></div>

	
	</div>
</template>

<script>
export default {
    data () {
      	return {
      	}
    },
    mounted:function(){
    	sessionStorage.setItem('actShopId',this.$route.params.id);
    },
    methods:{
		
    }
}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-field .van-icon{
		font-size: 20px;
	}
	/deep/ .van-cell__left-icon, .van-cell__right-icon{
		font-size: 20px;
	}
	/deep/ .van-dialog__confirm{   
        display:none
    }
	.home{
		width: 100%;
		height: 100vh;
	}
	.setting{
		text-align:center;
		color:#B8B8B8;
		font-size: 20px;
		margin-top: 35%;
	}
	.notice{
		word-break: break-all;
		padding: 0 10px;
	}
	.bottom{
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 60px;
		background: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/Shop/NoData.vue